export const FormTemplate = ({ children }: React.PropsWithChildren) => {
  return <div className="w-full">{children}</div>;
};
